import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PauseCircle, PlayCircle } from "lucide-react";
import { toast } from "sonner";

export default function DeactivatedBanner() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.status !== "deactivated" || ["owner", "admin", "brand_ambassador"].includes(user.role)) return null;

  const reactivate = async () => {
    setBusy(true);
    try { await api.post("/account/reactivate", {}); await refresh(); toast.success("Welcome back, your account is active again!"); }
    catch (e) { toast.error("Couldn't reactivate. Please try again."); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="deactivated-banner" className="bg-amber-500/15 border-b border-amber-500/30 text-amber-200">
      <div className="max-w-7xl mx-auto px-5 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm">
        <span className="flex items-center gap-2 font-medium">
          <PauseCircle className="w-4 h-4 shrink-0" /> Your account is <b>deactivated</b>, you're hidden from everyone, but your data is safe.
        </span>
        <button data-testid="banner-reactivate" onClick={reactivate} disabled={busy}
          className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-900 font-bold px-4 py-1.5 transition-colors disabled:opacity-60">
          <PlayCircle className="w-4 h-4" /> {busy ? "Reactivating…" : "Reactivate now"}
        </button>
      </div>
    </div>
  );
}
